import "./404.scss";

import { PageNotFoundElement } from "./PageNotFoundElement";

const PageNotFound = () => {
  return (
    <div className="not-found-wrapper">
      <PageNotFoundElement />
    </div>
  );
};

export default PageNotFound;
